import React from 'react';
import classNames from 'classnames';
import IProgress from './entities/IProgressNode';
import ABSProgressItem from './ABSProgressItem';
import DefaultTimeService from './services/impl/DefaultTimeService';
import { formatCycleData, formatNoBgCycleData } from './utils';
import _ from 'lodash';
import './index.less';

export interface IABSProgressProps {
  className?: string;
  dataSource: IProgress[];
  emptyText?: string;
  isWrap?: boolean;
  NoBg?: boolean;
}

export interface IABSProgressState {

}

class ABSProgress extends React.Component<IABSProgressProps, IABSProgressState> {
  render() {
    const { className, isWrap } = this.props;
    const progressStyle = classNames('abs-progress', {'abs-progress-wrap': isWrap}, className);
    return (
      <div className={progressStyle}>
        {this.renderTimelineItems()}
      </div>
    );
  }

  renderTimelineItems() {
    const { dataSource, emptyText, NoBg } = this.props;
    if (!Array.isArray(dataSource) || !dataSource.length) { 
      return <span className="abs-empty-text">{emptyText || '暂无数据'}</span>; 
    }
    let newDatas = _.cloneDeep(dataSource);
    newDatas = NoBg ? formatNoBgCycleData(newDatas) : formatCycleData(newDatas);
    const timeService = new DefaultTimeService();
    const items = newDatas.map((value, index, array) => {
      const prev = index > 0 ? array[index - 1] : null;
      const next = index < array.length - 1 ? array[index + 1] : null;
      return (
        <ABSProgressItem
          key={index}
          current={value}
          prev={prev}
          next={next}
          timeService={timeService}
        />
      );
    });
    return items;
  }
}

export default ABSProgress;


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/ABSProgress/index.tsx